import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../containers';
import { Navbar } from '../../components';
import './Trapeza.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../assets/OEFE.jpg';
import labora from '../../assets/labora.jpg';
import edu4schools from '../../assets/edu4schools.png';
import ypourgeio from '../../assets/ypourgeio.jpg';

const Trapeza = () => {
  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };
  return (
    <div className="Trapeza">
        <div className="gradient__bg">
          <Navbar className="navbar"/>
        </div>
        <div className="Trapeza__main-container">
          <div className="Trapeza__container">
            <div className="Trapeza__container-h">
              <h1>Τράπεζα Θεμάτων</h1>
            </div>
            <div className="Trapeza__container-p">
              <p>&nbsp;&nbsp;&nbsp;Η Τράπεζα Θεμάτων αποτελεί μέσο υποστήριξης της μάθησης και της διδασκαλίας και ως τέτοιο πρέπει πρώτα από όλα να αντιμετωπίζεται. Ως παιδαγωγικό εργαλείο υπηρετεί τη διαδικασία αξιολόγησης και στόχο της έχει να διευκολύνει και όχι να ελέγξει, να προσανατολίσει και όχι να δεσμεύσει. Παράλληλα, αποτελεί μια βάση πληροφοριών που υπερβαίνει τη χρηστικότητα της βαθμολόγησης και δίνει δυνατότητα για ευρύτερη αποτίμηση και επανασχεδιασμό του μαθήματος και της διδακτικής πράξης.</p>
              <p>&nbsp;&nbsp;&nbsp;Ως ψηφιακή βάση θεμάτων αποβαίνει αποτελεσματική, αν τα επιλεγόμενα θέματα προς αξιολόγηση των μαθητών/τριων συμβάλλουν στην εξασφάλιση των αρχών: της  εγκυρότητας, της αξιοπιστίας και της αντικειμενικότητας.</p>
              <p>&nbsp;&nbsp;&nbsp;ΔΕΣ <a href="https://trapeza.iep.edu.gr/public/subjects.php" target="_blank" rel="noopener noreferrer" style={{ color: '#05B2DC', textDecoration: 'underline' }}>ΕΔΩ</a> ΤΑ ΘΕΜΑΤΑ ΤΗΣ ΤΡΑΠΕΖΑΣ ΘΕΜΑΤΩΝ</p>
            </div>
          </div>
          <div className="Trapeza__side-Containers">
              <div className="Trapeza__side-Container1">
                <h1>Χρήσιμες Σελίδες</h1>
                <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
              </div>
              <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
            </div>
            </div>
        <Footer />
    </div>
  )
}

export default Trapeza